import * as WidgetForm from 'components/form/WidgetForm';
import { useGivebutterFormContext } from 'components/form/useGivebutterFormContext';

const WidgetComponentFormInputs = () => {
    const { watch } = useGivebutterFormContext<WidgetForm.WidgetFormValues>();

    const widgetType = watch('widgetType');
    const type = watch('type');

    const isButton = widgetType === 'button';
    const isGoalBar = widgetType === 'goal-bar';
    const isGivingForm = widgetType === 'giving-form';

    const isButtonTypeFloating = isButton && type !== 'static';
    const isGoalBarTypeProgressBar = isGoalBar && type === 'progress-bar';

    const isButtonOrProgressBar = isButton || isGoalBarTypeProgressBar;

    return (
        <>
            {isGivingForm && <WidgetForm.DisplayGoalBarInput />}
            {isButton && <WidgetForm.ButtonTypeInput />}
            {isButtonTypeFloating && <WidgetForm.PositionInput />}
            {isGoalBar && <WidgetForm.GoalBarTypeInput />}
            {isGoalBarTypeProgressBar && <WidgetForm.SizeInput />}
            {isGoalBar && <WidgetForm.TextColorInput />}
            {isGoalBar && <WidgetForm.ProgressBarColor />}
            {isButtonOrProgressBar && <WidgetForm.BackgroundColorInput />}
            {isButton && <WidgetForm.LabelInput />}
            {isButtonOrProgressBar && <WidgetForm.BorderWidthInput />}
            {isButtonOrProgressBar && <WidgetForm.BorderColorInput />}
            {isButtonOrProgressBar && (
                <>
                    <WidgetForm.BorderRadiusInput />
                    {isGoalBarTypeProgressBar && <div>&nbsp;</div>}
                </>
            )}
            {isButton && <WidgetForm.LabelColorInput />}
            {isButton &&
                (isButtonTypeFloating ? <WidgetForm.IconInput /> : <WidgetForm.ShadowInput />)}
            {isButton &&
                (isButtonTypeFloating ? <WidgetForm.ShadowInput /> : <WidgetForm.IconInput />)}

            {(isButton || isGoalBar || isGivingForm) && (
                <div className={isGoalBarTypeProgressBar || isGivingForm ? 'col-span-2' : ''}>
                    <WidgetForm.Preview />
                </div>
            )}
        </>
    );
};

export { WidgetComponentFormInputs };
